import { connect } from 'react-redux';
import _groupBy from 'lodash/groupBy';
import { selectAllSchedules } from '../ClasstivityScheduler.selectors';
import ClasstivitySchedulerTable from './ClasstivitySchedulerTable';

export const mapStateToProps = state => {
  const schedules = selectAllSchedules(state);
  const schedulesByDate = _groupBy(schedules ?? [], schedule => schedule.classDate) ?? {};
  return { schedulesByDate };
};

export default connect(mapStateToProps)(ClasstivitySchedulerTable);
